import { render } from "./App.vue?vue&type=template&id=55151ce6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=55151ce6&lang=scss"

import exportComponent from "D:\\mzl_contract\\mzl\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__